import styled, { keyframes } from 'styled-components';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Title = styled.h4`
  font-size: 20px;
  margin-bottom: 32px;
`;

const SearchContainer = styled.div`
  position: relative;
  svg {
    position: relative;
    left: -35px;
    top: 5px;
  }
`;

const FeaturesContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 20px;
`;

const Subtitle = styled.span`
  margin-bottom: 4px;
`;

const SearchBox = styled.input`
  width: 642px;
  height: 48px;
  padding-right: 35px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGray')};
  text-indent: 12px;
  margin-bottom: 12px;
  :focus {
    border: 1px solid ${getColor('primary')};
  }
  ${withQuery.xs.down()} {
    width: 328px;
  }
`;

const ListSuggestion = styled.div`
  position: absolute;
  background-color: ${select('white')};
  z-index: 1;
  left: 0;
  top: 100%;
  width: 392px;
  padding: 10px 0px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGray')};
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
  max-height: 200px;
  overflow-x: hidden;
  .not-found {
    margin-left: 12px;
  }
  ${withQuery.xs.down()} {
    width: 328px;
  }
`;

const Suggestion = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  .name {
    font-size: 14px;
    font-family: hind;
    font-weight: 600;
    margin-left: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
  }
  .category {
    color: ${select('darkGray')};
    margin-right: 12px;
  }
  :hover {
    background: ${select('lightGray')};
  }
`;

const PillContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 480px;
  flex-wrap: wrap;
  overflow: hidden;
  ${withQuery.xs.down()} {
    width: 328px;
  }
`;

const Pill = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  height: 40px;
  margin: 4px;
  padding: 4px 4px 0px 8px;
  background: ${select('midLightGray')};
  span {
    margin-right: 8px;
  }
`;

const ShowMore = styled.div`
  display: ${props => (props.showMe ? 'block' : 'none')};
  padding: 5px;
  font-family: Hind;
  font-weight: 600;
  max-width: 210px;
  cursor: pointer;
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const ImgClose = styled.div`
  width: 13px;
  height: 13px;
  background-color: ${getColor('primary')};
  border-radius: 50%;
  margin-right: 9px;
  cursor: pointer;
`;

const DropAmenitie = styled.div`
  width: 642px;
  border-top: 1px solid ${select('middleGray')};
  padding-top: 16px;
  margin-bottom: 16px;
  :first-child {
    border-top: none;
  }
  ${withQuery.xs.down()} {
    width: 328px;
  }
`;

const ToggleAmenities = styled.button`
  display: flex;
  align-items: center;
  width: 642px;
  justify-content: space-between;
  cursor: pointer;
  span {
    margin-right: 8px;
    font-size: 16px;
  }
  ${withQuery.xs.down()} {
    width: 328px;
  }
`;

const DropsContainer = styled.div`
  display: flex;
  flex-flow: column;
`;

const dropDown = keyframes`
  0% {
    transform: scaleY(0)
  }
  100% {
    transform: scaleY(1)
  }
`;

const ListCheckbox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: 20px;
  height: ${props => props.amenites}px;
  width: 642px;
  display: ${props => (props.showing ? 'flex' : 'none')};
  transition: max-height 1s ease;
  overflow: hidden;
  animation: ${dropDown} 300ms ease-in-out backwards;
  transform-origin: top center;
  div {
    width: 33%;
    ${withQuery.xs.down()} {
      width: 50%;
    }
  }
  ${withQuery.xs.down()} {
    width: 360px;
    height: ${props => props.amenitesmobile}px;
  }
`;

export {
  Title,
  Subtitle,
  FeaturesContainer,
  SearchBox,
  ListSuggestion,
  Suggestion,
  SearchContainer,
  PillContainer,
  Pill,
  DropAmenitie,
  ShowMore,
  ToggleAmenities,
  DropsContainer,
  ListCheckbox,
  ImgClose
};
